import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Clipboard_Check.svg'
import _imports_1 from '@/assets/close-icon-2.svg'
import _imports_2 from '@/assets/warning-red-rounded.svg'
import _imports_3 from '@/assets/prev-btn-arrow-left.svg'


const _hoisted_1 = { class: "w-full h-screen fixed top-0 left-0 bg-black/75 z-[1000]" }
const _hoisted_2 = { class: "w-full max-w-[1234px] px-[20px] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[7px] bg-white z-[1000]" }
const _hoisted_3 = { class: "flex items-center justify-between py-[16px] mb-[16px] border-b border-[#E3E1EA]" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "ml-[8px] text-[20px] font-semibold text-[#393840]" }
const _hoisted_6 = { class: "max-h-[400px] overflow-x-auto border-b border-[#E3E1EA] rounded-tl-[7px] flex flex-col" }
const _hoisted_7 = { class: "min-w-full border-separate border-spacing-[0.5px]" }
const _hoisted_8 = { class: "bg-[#F9F8F6]" }
const _hoisted_9 = { class: "w-1/6 p-[12px] text-left text-[16px] font-semibold text-[#393840] border border-[#E3E1EA] border-b-0" }
const _hoisted_10 = { class: "w-1/6 p-[12px] text-left text-[16px] font-semibold text-[#393840] border border-[#E3E1EA] border-b-0" }
const _hoisted_11 = { class: "w-1/6 p-[12px] text-left text-[16px] font-semibold text-[#393840] border border-[#E3E1EA] border-b-0" }
const _hoisted_12 = { class: "w-1/6 p-[12px] text-left text-[16px] font-semibold text-[#393840] border border-[#E3E1EA] border-b-0" }
const _hoisted_13 = { class: "w-1/6 p-[12px] text-left text-[16px] font-semibold text-[#393840] border border-[#E3E1EA] border-b-0" }
const _hoisted_14 = { class: "w-1/6 p-[12px] text-left text-[16px] font-semibold text-[#393840] border border-[#E3E1EA] border-b-0" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "p-[12px] text-[16px] text-[#393840] border border-[#E3E1EA]" }
const _hoisted_17 = { class: "p-[12px] text-[16px] text-[#393840] border border-[#E3E1EA]" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center gap-[1px] mb-[16px] mt-[6px]"
}
const _hoisted_19 = { class: "text-sm text-[#ed857f]" }
const _hoisted_20 = { class: "py-[12px] flex items-center justify-between" }
const _hoisted_21 = { class: "text-[#393840]" }
const _hoisted_22 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_23 = { key: 1 }

import { ref } from "vue";
import { useTranslate } from "@/composables/useTranslate";
import SpinnerLoader from "../Loaders/SpinnerLoader.vue";
import { WorkerBonus } from "@/types";

type Props = {
  isReportDialogOpen: boolean;
  workersBonuses: Array<WorkerBonus>;
  selectedMonth: any;
  selectedYear: any;
  areBonusesValid: boolean;
};

type Emits = {
  (event: "onClose"): void;
  (event: "decreaseDialogStage"): void;
  (event: "submitReport"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BonusReportReview',
  props: {
    isReportDialogOpen: { type: Boolean },
    workersBonuses: {},
    selectedMonth: {},
    selectedYear: {},
    areBonusesValid: { type: Boolean }
  },
  emits: ["onClose", "decreaseDialogStage", "submitReport"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const { t } = useTranslate();

const isLoading = ref(false);

const handleClose = () => {
  emits("onClose");
};
const handleBack = () => {
  emits("decreaseDialogStage");
};
const handleForward = () => {
  isLoading.value = true;
  emits("submitReport");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "nested" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                class: "w-[24px] h-[24px]",
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("installers.review_bonus_report")) + " " + _toDisplayString(__props.selectedMonth.name) + " " + _toDisplayString(__props.selectedYear.id), 1)
            ]),
            _createElementVNode("img", {
              class: "h-[12px] w-[12px] cursor-pointer",
              src: _imports_1,
              alt: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClose()))
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", _hoisted_8, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(t)("installers.review_table_column_name")), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(t)("installers.review_table_column_email")), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_unref(t)("installers.review_table_column_total_bonus")), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_unref(t)("installers.review_table_column_scaffolding")), 1),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_unref(t)("installers.review_table_column_commercial")), 1),
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_unref(t)("installers.review_table_column_bonus_payout")), 1)
                ])
              ]),
              _createElementVNode("tbody", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workersBonuses, (workerBonus, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(workerBonus.name), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(workerBonus.email), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(["p-[12px] text-[16px] text-[#393840] border", `${
                    workerBonus.bonusTotal.valid
                      ? 'border-[#E3E1EA]'
                      : 'border-[#ED857F] bg-[#fde1e0]'
                  }`])
                    }, _toDisplayString(workerBonus.bonusTotal.value) + "€ ", 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["p-[12px] text-[16px] text-[#393840] border border-[#E3E1EA]", `${
                    workerBonus.scaffoldingTotal.valid
                      ? 'border-[#E3E1EA]'
                      : 'border-[#ED857F] bg-[#fde1e0]'
                  }`])
                    }, _toDisplayString(workerBonus.scaffoldingTotal.value) + "€ ", 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["p-[12px] text-[16px] text-[#393840] border border-[#E3E1EA]", `${
                    workerBonus.commercialTotal.valid
                      ? 'border-[#E3E1EA]'
                      : 'border-[#ED857F] bg-[#fde1e0]'
                  }`])
                    }, _toDisplayString(workerBonus.commercialTotal.value) + "€ ", 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["p-[12px] text-[16px] text-[#393840] border border-[#E3E1EA]", `${
                    workerBonus.bonusPayoutTotal.valid
                      ? 'border-[#E3E1EA]'
                      : 'border-[#ED857F] bg-[#fde1e0]'
                  }`])
                    }, _toDisplayString(workerBonus.bonusPayoutTotal.value) + "€ ", 3)
                  ]))
                }), 128))
              ])
            ]),
            (!__props.areBonusesValid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[4] || (_cache[4] = _createElementVNode("img", {
                    class: "w-3 h-3",
                    src: _imports_2
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)("installers.error_upload_again")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleBack())),
              class: "min-w-[150px] flex items-center justify-center p-[12px] gap-[8px] text-[16px] text-white font-semibold border-2 border-[#393840] rounded-[7px]"
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("img", {
                class: "w-[18px] h-[18px]",
                src: _imports_3,
                alt: ""
              }, null, -1)),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)("installers.back_to_edit")), 1)
            ]),
            (
              __props.areBonusesValid && __props.workersBonuses && __props.workersBonuses.length > 0
            )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleForward())),
                  class: "w-[150px] flex items-center justify-center p-[12px] gap-[8px] text-[16px] text-white font-semibold bg-[#393840] rounded-[7px]"
                }, [
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(SpinnerLoader)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(t)("global.submit")), 1))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})